import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from "react";
import { date } from "@crehana/utils";
var useLiveState = function useLiveState(_ref) {
  var isLive = _ref.isLive,
    startLive = _ref.startLive,
    dueLive = _ref.dueLive;
  var intervalRef = useRef(0);
  var _useState = useState(isLive ? 'live' : 'future'),
    _useState2 = _slicedToArray(_useState, 2),
    liveState = _useState2[0],
    setLiveState = _useState2[1];
  useEffect(function () {
    // Validate initial live state
    setLiveState(date.getLiveState(startLive, dueLive));
    // Validate every 5 minutes
    intervalRef.current = setInterval(function () {
      var newLiveState = date.getLiveState(startLive, dueLive);
      if (newLiveState === 'past') {
        clearInterval(intervalRef.current);
      }
      setLiveState(newLiveState);
    }, 5 * 1000 * 60);
    return function () {
      return clearInterval(intervalRef.current);
    };
  }, [startLive, dueLive]);
  return {
    liveState: liveState
  };
};
export default useLiveState;